






























import Vue from 'vue'

import types from '../../store/types'

import FileSelector from '../FileSelector.vue'
import ControllerWrap from './ControllerWrap.vue'
import RotateController from './RotateController.vue'
import ScaleController from './ScaleController.vue'
import ShapeController from './ShapeController.vue'

export default Vue.extend({
  components: {
    FileSelector,
    ControllerWrap,
    RotateController,
    ScaleController,
    ShapeController
  },

  computed: {
    active: {
      get(): number {
        return this.$store.state.Navigation.active
      },
      set(active: number): void {
        this.$store.commit(types.mutations.NAVIGATION_ACTIVE, active)
      }
    }
  },

  methods: {
    changeController(index: number) {
      if (this.active === index) {
        this.active = 0
      } else {
        this.active = index
      }
    },
    selectFile(e: FileReader | null) {
      this.$store.commit(types.mutations.NAVIGATION_ACTIVE, 0)
      this.$store.commit(types.mutations.CURRENT_FILE, e)
    }
  }
})
